import { formatMoney } from "../../../infra/helpers";
import type { ColumnsType } from 'antd/es/table';
import { formatBrDate } from "../../../infra/helpers/date";
import { formatNumber } from "../../../infra/helpers/number";

export interface DataType {
  key: React.Key;
  DataMovimento: string;
  MovimentoTipo: string;
  ProdutoCodigoFornecedor: number;
  ProdutoNome: string;
  Botijao: string;
  Caneca: string;
  ValorUnitarioReais: number;
  DescontoPorcentagem: number;
  Quantidade: number;
}

export const columnsMovimentos: ColumnsType<DataType> = [
  {
    title: "Data",
    dataIndex: "DataMovimento",
    key: "DataMovimento",
    width: 50,
    render(data: any) {
      return formatBrDate(data);
    },
  },
  {
    title: "Tipo",
    dataIndex: "MovimentoTipo",
    key: "MovimentoTipo",
    filters: [
      {
        text: 'CI - Entrada',
        value: 'CI - Entrada',
      },
      {
        text: 'CI - Saída',
        value: 'CI - Saída',
      },
      {
        text: 'Nota Fiscal',
        value: 'Nota Fiscal',
      },
    ],
    filterMultiple: false,
    onFilter: (value: any, record) => record.MovimentoTipo.indexOf(value) === 0,
  },
  {
    title: "Cod Produto",
    dataIndex: "ProdutoCodigoFornecedor",
    key: "ProdutoCodigoFornecedor",
    width: 110,
  },
  {
    title: "Produto",
    dataIndex: "ProdutoNome",
    key: "ProdutoNome",
  },
  {
    title: "Botijão",
    dataIndex: "Botijao",
    key: "Botijao",
  },
  {
    title: "Caneca",
    dataIndex: "Caneca",
    key: "Caneca",
  },
  {
    title: "Valor Unitário",
    dataIndex: "ValorUnitarioReais",
    key: "ValorUnitarioReais",
    render(valor: number) {
      return formatMoney(valor);
    },
    align: "right",
    width: 110,
  },
  {
    title: "Desconto",
    dataIndex: "DescontoPorcentagem",
    key: "DescontoPorcentagem",
    align: "right",
    width: 70,
    render: (record: number) => {
      return (
        <span>{formatNumber(record)}%</span>
      )
    }
  },
  {
    title: "Qtde",
    dataIndex: "Quantidade",
    key: "Quantidade",
    align: "right",
    width: 60,
  },
];
